module.exports = __webpack_public_path__ + "static/media/30-points.eed93413.png";